import Cookies from 'universal-cookie';

export async function fetchWith401Check(url, options) {
  const response = await fetch(url, options);

  if (!response.ok) {
    if (response.status === 401) {
      // Handle 401 error here
      // For example, you can redirect the user to a login page
      const cookies = new Cookies();
      cookies.remove('token', { path: '/' });
      window.location.href = '/portal/auth';
    } else {
      throw new Error('Request failed with status ' + response.status);
    }
  }

  return response;
}
